export const enum BarType {
	MoneyIn = 'moneyIn',
	MoneyOut = 'moneyOut',
	Empty = 'empty',
}
